import { render, staticRenderFns } from "./InternalImageContent.vue?vue&type=template&id=10ff17f5&scoped=true"
import script from "./InternalImageContent.vue?vue&type=script&lang=js"
export * from "./InternalImageContent.vue?vue&type=script&lang=js"
import style0 from "./InternalImageContent.vue?vue&type=style&index=0&id=10ff17f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff17f5",
  null
  
)

export default component.exports